import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div id="footer">
      <span className="footertext">
        <div id="footerleft">
          <Link to="/privacy">Privacy-Policy</Link> | <Link to="/terms">Terms Of Use</Link> Copyrights 2024. All rights Reserved.
        </div>
        <div id="footerright">Powered by SOLLICS</div>
      </span>
    </div>
  );
}

export default Footer;
